import { useDispatch } from 'react-redux'
import {
  setChatModalState,
  setChatScreen,
  setCurrentTopic,
  setTopicList,
} from '../../store/slices/chatSlice'
import { useCallback, useState } from 'react'
import { ChatScreens, Group } from '../types/enums'
import { getApi } from '../../api/api'
import { CargoItemInterface, SlotItemInterface, TransportItemInterface } from '../types/interfaces'
import { v4 } from 'uuid'

export const useChatForOrders = () => {
  const [api] = useState(getApi())
  const dispatch = useDispatch()

  const getTopicList = useCallback(
    async (userId: number) => {
      try {
        const result = await api.getTopicList(userId)
        if (result.length > 0) dispatch(setTopicList(result))
        return result
      } catch (error) {}
    },
    [api, dispatch],
  )

  const openChatWindow = useCallback(
    async (
      order: SlotItemInterface | CargoItemInterface | TransportItemInterface,
      group: Group,
      userId: number,
    ) => {
      try {
        const topicsList = await getTopicList(userId)
        const field =
          group === Group.CARGO ? 'cargoId' : group === Group.TRANSPORT ? 'transportId' : 'slotId'
        const weHaveIt = topicsList?.find(
          (el) =>
            (el.userId === userId || el.participantId === userId) &&
            el[field] === order.id,
        )
        if (!weHaveIt) { 
          const result = await api.createTopic({
            uuid: v4(),
            group,
            orderId: order.id,
            userId,
            participantId: order.userId,
            slotId: group === Group.SLOT ? order.id : undefined,
            cargoId: group === Group.CARGO ? order.id : undefined,
            transportId: group === Group.TRANSPORT ? order.id : undefined,
            messages: [],
          })
          await getTopicList(userId)
          dispatch(setCurrentTopic(result))
        } else {
          dispatch(setCurrentTopic(weHaveIt))
        }
        dispatch(setChatScreen(ChatScreens.WINDOW))
        dispatch(setChatModalState(true))
      } catch (error) {}
    },
    [api, dispatch, getTopicList],
  )

  return { openChatWindow }
}
